export const TestIds = {
  content: 'header-container-content',
} as const;

export const corvidName = '$w.Header';
